// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"6695bdc1","787":"fb771931","886":"40f32987"}[chunkId] + ".chunk.js";
};